(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-description"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    const readMoreBtn = document.querySelector('.read_more');
    const readLessBtn = document.querySelector('.read_less');
    const beforeDesc = document.querySelector('.product__description.before');
    const afterDesc = document.querySelector('.product__description.after');

    if (readMoreBtn) {
      readMoreBtn.addEventListener('click', function () {
        beforeDesc.style.display = 'none';
        afterDesc.style.display = 'block';
      });
    }

    if (readLessBtn) {
      readLessBtn.addEventListener('click', function () {
        afterDesc.style.display = 'none';
        beforeDesc.style.display = 'block';
      });
    }
  });
  } catch(e) { console.error(e); }
})();

})();
